export default __webpack_public_path__ + "static/media/hhn1.d0d132b4.png";